import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import { notify } from "@/components/framework/notify";
import i18n from "@/i18n";

const useCreateUnverifiedCompanyAccount = ({ onSuccess, onError } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["createUnverifiedCompanyAccount"],
    mutationFn: (payload) => {
      return apiClient.post("/companies/active/unverified", payload);
    },
    onSuccess: async (mutationResponse, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: ["userCompanies"] });

      onSuccess?.(mutationResponse, variables, context);
    },
    onError: (error, variables, context) => {
      const translationId = error?.response?.data?.translationId;

      notify("error", i18n.t(translationId || "generic.unknown_error"));

      onError?.(error, variables, context);
    },
  });
};

export { useCreateUnverifiedCompanyAccount };
